import { render } from "./ProdutosEdit.vue?vue&type=template&id=1704a3f6&scoped=true"
import script from "./ProdutosEdit.vue?vue&type=script&lang=js"
export * from "./ProdutosEdit.vue?vue&type=script&lang=js"

import "./ProdutosEdit.vue?vue&type=style&index=0&id=1704a3f6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3986129723/src/app-csd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1704a3f6"]])

export default __exports__